module.exports = __webpack_public_path__ + "img/mask-group-2.55a667e6.png";